<template>
  <div class="fillOut">
    <el-form ref="formData" :model="formData" class="baseInfoForm">
      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              订单编号：
            </div>
            <div class="rj-baseinfo__item">
              {{ formData.orderNum }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              金税发票类型：
            </div>
            <div class="rj-baseinfo__item">
              {{ formData.invoiceTypeStr }}
            </div>
          </div>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              发票标记：
            </div>
            <div class="rj-baseinfo__item">
              {{ formData.invoiceMarkStr }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              订单客户编号：
            </div>
            <div class="rj-baseinfo__item">
              {{ formData.orderUnitCode }}
            </div>
          </div>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              订单客户名称：
            </div>
            <div class="rj-baseinfo__item">
              {{ formData.orderUnit }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              税率：
            </div>
            <div class="rj-baseinfo__item">
              {{ formData.taxRate }}
            </div>
          </div>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              开票客户编号：
            </div>
            <div class="rj-baseinfo__item">
              {{ formData.bankInfo && formData.bankInfo.kpOrderUnitCode }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              开票客户名称：
            </div>
            <div class="rj-baseinfo__item">
              {{ formData.bankInfo && formData.bankInfo.kpOrderUnit }}
            </div>
          </div>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              开票纳税人识别号：
            </div>
            <div class="rj-baseinfo__item">
              {{ formData.bankInfo && formData.bankInfo.kpTaxpayerNum }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              纳税登记地址：
            </div>
            <div class="rj-baseinfo__item">
              {{ formData.bankInfo && formData.bankInfo.taxRegistrationAddress }}
            </div>
          </div>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              税务登记电话：
            </div>
            <div class="rj-baseinfo__item">
              {{ formData.bankInfo && formData.bankInfo.taxRegistrationTelephone }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              开户行：
            </div>
            <div class="rj-baseinfo__item">
              {{ formData.bankInfo && formData.bankInfo.bankDeposit }}
            </div>
          </div>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              银行账号：
            </div>
            <div class="rj-baseinfo__item">
              {{ formData.bankInfo && formData.bankInfo.bankAccount }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              收函人：
            </div>
            <div class="rj-baseinfo__item">
              {{ formData.bankInfo && formData.bankInfo.receiveUser }}
            </div>
          </div>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              收函人电话：
            </div>
            <div class="rj-baseinfo__item">
              {{ formData.bankInfo && formData.bankInfo.receiveTelephone }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              收函单位：
            </div>
            <div class="rj-baseinfo__item">
              {{ formData.bankInfo && formData.bankInfo.receiveCompany }}
            </div>
          </div>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              收函地址：
            </div>
            <div class="rj-baseinfo__item">
              {{ formData.bankInfo && formData.bankInfo.receiveAddress }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              开票备注：
            </div>
            <div class="rj-baseinfo__item">
              {{ formData.remark }}
            </div>
          </div>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              发票接收邮箱：
            </div>
            <div class="rj-baseinfo__item">
              {{ formData.invoiceEmail }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              <i style="color: red">*</i>
              发票代码：
            </div>
            <div class="rj-baseinfo__item">
              <el-input v-model="formData.invoiceCode" placeholder="请输入发票代码" />
            </div>
          </div>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              <i style="color: red">*</i>
              金税发票编号：
            </div>
            <div class="rj-baseinfo__item">
              <el-input v-model="formData.invoiceNo" placeholder="请输入金税发票编号" />
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              <i style="color: red">*</i>
              金税发票日期：
            </div>
            <div class="rj-baseinfo__item">
              <el-date-picker
                v-model="formData.invoiceDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              快递单号：
            </div>
            <div class="rj-baseinfo__item">
              <el-input v-model="formData.logisticsNo" placeholder="请输入快递单号" />
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              出口发票号：
            </div>
            <div class="rj-baseinfo__item">
              <el-input v-model="formData.exportInvoiceNo" placeholder="请输入出口发票号" />
            </div>
          </div>
        </div>
      </div>

      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              产品信息
            </div>
          </div>
        </div>
      </div>
      <el-table
        :summary-method="handleTotal"
        :data="productList"
        show-summary
        border
        style="width: 100%"
      >
        <el-table-column type="index" prop="index" label="序号" align="left" fixed="left" />
        <el-table-column prop="productCode" label="销售产品代码" width="100" align="left" />
        <el-table-column prop="productName" label="销售产品名称" width="200" align="left" />
        <el-table-column prop="productNum" label="数量" align="left" />
        <el-table-column prop="settlementUnitPrice" label="实际结算单价" width="100" align="right" header-align="left" />
        <el-table-column prop="settlementAmount" label="实际结算金额" width="100" align="right" header-align="left" />
        <el-table-column prop="amountExcludingTax" label="不含税金额" width="100" align="right" header-align="left" />
        <el-table-column prop="taxAmount" label="税额" align="right" header-align="left" min-width="110" />
        <el-table-column prop="expectedDeliveryDate" label="客户期望发货日" width="150" align="left" />
        <el-table-column prop="agreedDeliveryDate" label="约定交付日期" width="150" align="left" />
        <el-table-column prop="taxRate" label="税率" align="right" header-align="left">
          <template v-slot="{row}">
            <span>{{ row.taxRate ? `${row.taxRate}%` : '' }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </div>
</template>

<script>
import { MathAdd } from '@/libs/util';
export default {
  props: {
    formData: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    productList () {
      if (!this.formData.productList) return [];
      return this.formData.productList;
    }
  },

  data () {
    return {};
  },

  methods: {
    handleTotal (params) {
      const { columns } = params;
      const tempTotal = ['合计'];
      columns.forEach((item, index) => {
        if (item.property === 'productNum') { // 数量
          tempTotal[index] = this.allAmount('productNum');
        } else if (item.property === 'settlementAmount') { // 实际结算金额
          tempTotal[index] = this.allAmount('settlementAmount');
        } else if (item.property === 'amountExcludingTax') { // 不含税金额
          tempTotal[index] = this.allAmount('amountExcludingTax');
        } else if (item.property === 'taxAmount') { // 税额
          tempTotal[index] = this.allAmount('taxAmount');
        }
      });
      return tempTotal;
    },

    allAmount (type) {
      let cont = 0;
      (this.productList || []).forEach((item) => {
        cont = MathAdd(cont, item[type]);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    }
  }
};
</script>
